///---------------------------------------------------------------------------
//! Copyright (C) ASQUARED SRL - All Rights Reserved
//* Unauthorized copying of this file, via any medium is strictly prohibited
//* Proprietary and confidential
//? @author g99.alex@yahoo.com
///---------------------------------------------------------------------------

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { COMPANY } from '../services/CompanyService'

//-----------------------------------------------------------------------------------------
//* \brief
//? Delivery policy and order cancellation policy, both required before a card processor
//? will enable payments.
//?
//? One page with two anchored sections rather than two routes: the footer links to
//? #livrare and #anulare separately, so each policy is reachable under its own name, which
//? is what a reviewer looks for.
//-----------------------------------------------------------------------------------------
const OrderPolicies = () => {
  return (
    <div className='terms-wrapper'>
        <Helmet>
            <title>Politica de livrare și de anulare a comenzii — Program Intrastat</title>
            <meta name='description' content={
                'Cum se livrează abonamentul programintrastat.ro după plată, cum se anulează o ' +
                'comandă și în ce condiții se restituie sumele achitate.'
            } />
        </Helmet>

        <h1>Politica de livrare și de anulare a comenzii</h1>

        {/* ------------------------------------------------------------------ LIVRARE */}
        <div id='livrare'>
            <div>
                <h1>1. Politica de livrare a comenzii</h1>

                <div>1.1. Serviciile oferite prin platforma {COMPANY.site} sunt <b>servicii digitale</b>.
                    Nu se livrează bunuri fizice, nu se percep taxe de transport și nu este necesară
                    prezența Clientului pentru recepție.</div>

                <div>1.2. „Livrarea" constă în <b>activarea abonamentului</b> în contul Clientului de pe
                    platformă. Din acel moment Clientul poate genera declarații Intrastat în limitele
                    pachetului achiziționat.</div>

                <div>1.3. Termenul de livrare depinde de modalitatea de plată aleasă:</div>
                <ul>
                    <li><b>Plată online cu cardul</b> — abonamentul se activează <b>automat, în câteva
                        secunde</b> de la confirmarea plății de către procesatorul de plăți. Nu este
                        necesară nicio acțiune suplimentară din partea Clientului.</li>
                    <li><b>Plată prin transfer bancar (ordin de plată)</b> — abonamentul se activează
                        <b> după confirmarea încasării</b> în contul Prestatorului, de regulă în
                        <b> 1-2 zile lucrătoare</b> de la data creditării contului. Pentru o activare mai
                        rapidă, Clientul poate transmite dovada plății la adresa {COMPANY.email}.</li>
                </ul>

                <div>1.4. Starea comenzii poate fi verificată în orice moment de către Client, autentificat
                    în cont, în secțiunea <b>„Plăți"</b>. Acolo sunt afișate atât comenzile neachitate, cât
                    și cele achitate, împreună cu facturile aferente.</div>

                <div>1.5. Factura aferentă comenzii este emisă electronic și este disponibilă pentru
                    vizualizare și descărcare în secțiunea <b>„Plăți"</b> din contul Clientului. O
                    confirmare este transmisă și pe adresa de e-mail asociată contului.</div>

                <div>1.6. În cazul în care, din motive tehnice, abonamentul nu este activat în termenele de
                    mai sus deși plata a fost efectuată, Clientul este rugat să ne contacteze la
                    adresa {COMPANY.email}. Prestatorul va remedia situația fără costuri suplimentare
                    pentru Client.</div>
            </div>
        </div>

        {/* ------------------------------------------------------------------ ANULARE */}
        <div id='anulare'>
            <div>
                <h1>2. Politica de anulare a comenzii</h1>

                <div>2.1. <b>Înainte de efectuarea plății</b>, Clientul poate anula oricând comanda, direct
                    din contul său, din secțiunea <b>„Plăți"</b>, folosind butonul <b>„Anulează"</b> afișat
                    în dreptul comenzii neachitate. Anularea este imediată și nu implică niciun cost.</div>

                <div>2.2. La anularea unei comenzi neachitate, abonamentul neactivat este dezactivat, iar
                    abonamentul anterior, dacă este încă valabil, redevine activ. Clientul poate alege
                    ulterior orice alt abonament.</div>

                <div>2.3. <b>În cazul plății cu cardul care nu se finalizează</b> (plată refuzată, anulată de
                    Client sau întreruptă), <b>nu se reține nicio sumă</b> de pe cardul Clientului, iar
                    comanda rămâne valabilă și poate fi achitată ulterior, prin oricare dintre modalitățile
                    de plată disponibile.</div>

                <div>2.4. <b>După activarea abonamentului</b>, anularea se poate solicita prin e-mail la
                    adresa {COMPANY.email}, de pe adresa de e-mail asociată contului, menționând ID-ul
                    comenzii sau seria și numărul facturii. Prestatorul va răspunde solicitării în termen de
                    maximum <b>5 zile lucrătoare</b>.</div>

                <div>2.5. <b>Restituirea sumelor.</b> În situațiile în care restituirea este acordată,
                    aceasta se efectuează prin aceeași modalitate de plată folosită de Client — pentru
                    plățile cu cardul, suma este returnată pe același card — în termen de maximum
                    <b> 14 zile calendaristice</b> de la data acceptării solicitării. Restituirea nu implică
                    niciun cost pentru Client.</div>

                <div>2.6. Deoarece serviciul este furnizat integral în mediul online și este disponibil
                    imediat după activare, la stabilirea sumei restituite se poate ține cont de perioada în
                    care abonamentul a fost efectiv utilizat și de numărul de declarații generate.</div>

                <div>2.7. Serviciile oferite prin platforma {COMPANY.site} se adresează <b>persoanelor
                    juridice</b>, în scopul desfășurării activității lor economice. Prin urmare, dreptul de
                    retragere prevăzut de OUG nr. 34/2014 în favoarea consumatorilor persoane fizice nu este
                    aplicabil acestor contracte. Prevederile prezentei politici se aplică în completarea
                    <b> Termenilor și condițiilor</b>.</div>

                <div>2.8. Prestatorul își rezervă dreptul de a anula o comandă în cazul în care datele
                    furnizate de Client sunt incomplete sau incorecte, în cazul unei suspiciuni întemeiate
                    de fraudă, ori în situația în care plata nu poate fi confirmată. În aceste cazuri
                    Clientul este informat pe e-mail, iar eventualele sume încasate se restituie integral.</div>
            </div>
        </div>

        <div>
            <div>
                <h1>3. Contact</h1>
                <div>Pentru orice solicitare legată de livrarea sau anularea unei comenzi:</div>
                <div><b>{COMPANY.name}</b></div>
                <div>E-mail: {COMPANY.email}</div>
                <div>Datele complete de identificare și de contact sunt disponibile în secțiunea
                    <b> Termeni și condiții</b>.</div>
            </div>
        </div>
    </div>
  )
}

export default OrderPolicies
